import { render } from "./ErrorBanner.vue?vue&type=template&id=3d52106c&scoped=true"
import script from "./ErrorBanner.vue?vue&type=script&lang=js"
export * from "./ErrorBanner.vue?vue&type=script&lang=js"

import "./ErrorBanner.vue?vue&type=style&index=0&id=3d52106c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d52106c"]])

export default __exports__